import { useEffect } from 'react'
import { useWarehouseProblemStore } from '@/store/warehouseProblemStore'

/**
 * Seeds warehouse left-nav error counts from the daily nav-status snapshot.
 * Mounted once from App; no interval so live Warehouse-page counts are not clobbered.
 */
export function useWarehouseNavStatusPoller() {
  const fetchNavStatus = useWarehouseProblemStore((s) => s.fetchNavStatus)

  useEffect(() => {
    void fetchNavStatus()
  }, [fetchNavStatus])
}
